import React from "react"
import BodyText from "./BodyText"

const normalizeFootnotes = (html = "") => {
  const notes = []
  let fallbackIndex = 0

  const content = html.replace(/<sup\b([^>]*)>([\s\S]*?)<\/sup>/gi, (match, attrs, inner) => {
    const classMatch = attrs.match(/class\s*=\s*["']([^"']*)["']/i)
    const classNames = classMatch ? classMatch[1] : ""

    if (!/\bfootnote\b/.test(classNames)) {
      return match
    }

    fallbackIndex += 1

    const idMatch = attrs.match(/data-footnote-id\s*=\s*["']([^"']+)["']/i)
    const id = idMatch ? idMatch[1] : `fn-${fallbackIndex}`
    const refId = `${id}-ref`
    const text = inner.replace(/<[^>]+>/g, "").trim()

    notes.push({ id, refId, text })

    return `<sup class="footnote-ref" id="${refId}"><a href="#${id}">${notes.length}</a></sup>`
  })

  return { content, notes }
}

const FootnoteBody = ({ body }) => {
  const { content, notes } = normalizeFootnotes(body)

  return <React.Fragment>
    <BodyText body={content} />
    {notes.length ? <ol className="footnote-list">
      {notes.map((note, index) => {
        return <li key={`${note.id}-${index}`} id={note.id}>
          <a href={`#${note.refId}`} className="footnote-backref">{index + 1}.</a> {note.text}
        </li>
      })}
    </ol> : null}
  </React.Fragment>
}

export default FootnoteBody